var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiquidity = function SvgLiquidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5F5F5",
    strokeWidth: 1.5,
    d: "M18 1.75H6A4.25 4.25 0 0 0 1.75 6v12A4.25 4.25 0 0 0 6 22.25h12A4.25 4.25 0 0 0 22.25 18V6A4.25 4.25 0 0 0 18 1.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M6 11.3h2.357V19H6zM10.4 8h2.2v11h-2.2zm4.4 6.286H17V19h-2.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M19 7h-5l.938 1M14 6h5l-.937-1"
  })));
};
export default SvgLiquidity;